export const formatDate = (date, format = 'long') => {
    if(!date) {
        return;
    }

    const convertedDate = convertDate(date);
    switch (format) {
        case 'long':
            return new Date(convertedDate).toISOString().slice(0, 19).replace("T", " ");
        case 'medium':
            return new Date(convertedDate).toISOString().slice(0, 16).replace("T", " ");
        case 'small':
            return new Date(convertedDate).toISOString().slice(0, 10).replace("T", " ");
        default:
            return new Date(convertedDate).toISOString().slice(0, 10).replace("T", " ");
    }
};

const convertDate = (date) => new Date(date -  new Date(date).getTimezoneOffset() * 60000);

export const scrollToTop = () => {
    window.scrollTo(0, 0);
};
